var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableNotFoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 249,
    viewBox: "0 0 264 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.472 22.2766C149.638 20.3936 173.72 -9.60588 194.362 3.14743C215.269 16.065 197.321 52.8252 209.526 74.2082C221.665 95.4764 257.451 98.9883 262.726 122.921C267.777 145.836 246.937 166.257 234.146 185.903C221.924 204.674 209.322 223.858 189.851 234.852C170.475 245.793 147.126 252.313 125.472 247.265C104.8 242.445 94.8637 218.739 76.3178 208.383C57.342 197.787 30.6029 202.562 16.2015 186.249C1.59976 169.709 -0.54814 144.975 0.871371 122.921C2.24828 101.529 13.5569 82.8131 24.0605 64.1486C34.6496 45.3322 42.5817 21.6436 62.4925 13.4227C82.4367 5.18788 103.971 23.9519 125.472 22.2766Z",
    fill: "#ECF4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.619 133.307C112.54 133.86 112.5 134.425 112.5 135C112.5 141.627 117.873 147 124.5 147C131.127 147 136.5 141.627 136.5 135C136.5 134.425 136.46 133.86 136.381 133.307H165.5V160C165.5 161.657 164.157 163 162.5 163H86.5C84.8431 163 83.5 161.657 83.5 160V133.307H112.619Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.598 133.955C135.598 139.502 130.629 145 124.5 145C118.371 145 113.402 139.502 113.402 133.955C113.402 133.775 113.408 132.596 113.418 132.419H92.5L100.661 112.575C101.013 111.634 101.989 111 103.087 111H145.913C147.011 111 147.987 111.634 148.339 112.575L156.5 132.419H135.582C135.592 132.596 135.598 133.775 135.598 133.955Z",
    fill: "#E8F0FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.75 132.512V159C84.75 159.966 85.5335 160.75 86.5 160.75H162.5C163.466 160.75 164.25 159.966 164.25 159V132.512L154.755 104.439C154.515 103.728 153.848 103.25 153.098 103.25H95.9023C95.1519 103.25 94.485 103.728 94.2446 104.439L84.75 132.512Z",
    stroke: "#1F64E7",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5005 132C101.437 132 105.685 132 110.245 132C112.122 132 112.122 133.319 112.122 134C112.122 140.627 117.618 146 124.398 146C131.178 146 136.674 140.627 136.674 134C136.674 133.319 136.674 132 138.55 132H163.5M90.0742 132H92.5005H90.0742Z",
    stroke: "#1F64E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.6 79.3027L138.5 91.7559M123.6 75V91.7559V75ZM97.5 79.3027L108.6 91.7559L97.5 79.3027Z",
    stroke: "#75A4FE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNotFoundIcon);
export default __webpack_public_path__ + "static/media/table-not-found-icon.d8d8acfd6f1f8a24679383289be26ca2.svg";
export { ForwardRef as ReactComponent };